class EuroCddProcess extends HTMLElement {
  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll('[data-cdd-process-step]'));
    this.panel = this.querySelector('[data-cdd-process-panel]');
    this.panelImageDesktop = this.panel?.querySelector('[data-cdd-process-panel-image-desktop]');
    this.panelImageMobile = this.panel?.querySelector('[data-cdd-process-panel-image-mobile]');
    this.panelPlaceholder = this.panel?.querySelector('[data-cdd-process-panel-placeholder]');
    this.activeIndex = -1;

    this.onStepClick = (event) => {
      const button = event.currentTarget;
      const index = Number(button.dataset.cddProcessIndex);
      if (Number.isNaN(index)) return;
      this.selectStep(index);
    };

    this.steps.forEach((step) => {
      const button = step.querySelector('[data-cdd-process-trigger]');
      button?.addEventListener('click', this.onStepClick);
    });

    this.selectStep(0, { animate: false });
  }

  disconnectedCallback() {
    this.steps?.forEach((step) => {
      const button = step.querySelector('[data-cdd-process-trigger]');
      button?.removeEventListener('click', this.onStepClick);
    });
  }

  selectStep(index, { animate = true } = {}) {
    if (index < 0 || index >= this.steps.length) return;

    // FAQ toggle: clicking the open item collapses it.
    if (this.activeIndex === index) {
      this.activeIndex = -1;
      this.steps.forEach((step) => {
        const button = step.querySelector('[data-cdd-process-trigger]');
        step.classList.remove('is-active');
        button?.setAttribute('aria-expanded', 'false');
      });
      return;
    }

    this.activeIndex = index;
    const activeStep = this.steps[index];

    this.steps.forEach((step, i) => {
      const active = i === index;
      const button = step.querySelector('[data-cdd-process-trigger]');
      step.classList.toggle('is-active', active);
      button?.setAttribute('aria-expanded', active ? 'true' : 'false');
    });

    this.syncPanel(activeStep, { animate });
  }

  syncPanel(step, { animate = true } = {}) {
    if (!this.panel) return;

    const desktopSrc = step.dataset.imageDesktop || '';
    const mobileSrc = step.dataset.imageMobile || desktopSrc;

    if (this.panelImageDesktop) {
      if (desktopSrc) {
        this.panelImageDesktop.src = desktopSrc;
        this.panelImageDesktop.hidden = false;
      } else {
        this.panelImageDesktop.removeAttribute('src');
        this.panelImageDesktop.hidden = true;
      }
    }

    if (this.panelImageMobile) {
      if (mobileSrc) {
        this.panelImageMobile.src = mobileSrc;
        this.panelImageMobile.hidden = false;
      } else {
        this.panelImageMobile.removeAttribute('src');
        this.panelImageMobile.hidden = true;
      }
    }

    if (this.panelPlaceholder) {
      const hasImage = Boolean(desktopSrc || mobileSrc);
      this.panelPlaceholder.hidden = hasImage;
    }

    if (!animate) return;

    this.panel.classList.remove('is-animating');
    void this.panel.offsetWidth;
    this.panel.classList.add('is-animating');
  }
}

if (!customElements.get('euro-cdd-process')) {
  customElements.define('euro-cdd-process', EuroCddProcess);
}
